import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    numberCircleOutline: {
      position: 'relative',
      borderRadius: '50%',
      marginLeft: '28px',
      marginBottom: '28px',
      width: '28px',
      height: '28px',
      background: '#FFFFFF',
      color: '#3C419A',
      border: '1px solid #3C419A',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
      cursor: 'pointer',
    },
    numbersInCirclesOutline: {
      position: 'relative',
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      top: '2px',
      display: 'inline-block',
    },
    numberCircleInline: {
      position: 'relative',
      borderRadius: '50%',
      left: '22px',
      width: '30px',
      bottom: '5px',
      height: '30px',
      background: '#3C419A',
      color: '#FFFFFF',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      display: 'inline-block',
      alignContent: 'center',
    },
    numbersInCirclesInline: {
      position: 'relative',
      bottom: '3px',
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      marginTop: '8px',
      display: 'inline-block',
    },
    textOutline: {
      position: 'relative',
      bottom: '6px',
      left: '10px',
      fontSize: '13px',
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      display: 'inline-block',
      cursor: 'pointer',
    },
    textInline: {
      position: 'relative',
      bottom: '6px',
      left: '28px',
      fontSize: '13px',
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      display: 'inline-block',
      fontWeight: 'bold',
    },
    line: {
      position: 'relative',
      left: '16px',
      width: '123px',
      color: '#2c2d3e',
      opacity: 0.3,
      display: 'inline-block',
      align: 'center',
    },
  }),
);
